/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnExerciseType } from './en-exercise-type';
import { ExerciseDto } from './exercise-dto';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface SessionExerciseDto
 */
export interface SessionExerciseDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof SessionExerciseDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof SessionExerciseDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof SessionExerciseDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof SessionExerciseDto
     */
    deleted: string | null;

    /**
     * @type {number}
     * @memberof SessionExerciseDto
     */
    reps: number;

    /**
     * @type {number}
     * @memberof SessionExerciseDto
     */
    sets: number;

    /**
     * @type {number}
     * @memberof SessionExerciseDto
     */
    rest: number;

    /**
     * @type {number}
     * @memberof SessionExerciseDto
     */
    sequence: number;

    /**
     * @type {number}
     * @memberof SessionExerciseDto
     */
    speed: number;

    /**
     * @type {EnExerciseType}
     * @memberof SessionExerciseDto
     */
    type: EnExerciseType;

    /**
     * @type {number}
     * @memberof SessionExerciseDto
     */
    duration: number;

    /**
     * @type {JoinEntityDto}
     * @memberof SessionExerciseDto
     */
    session: JoinEntityDto;

    /**
     * @type {ExerciseDto}
     * @memberof SessionExerciseDto
     */
    exercise: ExerciseDto;

    /**
     * @type {string}
     * @memberof SessionExerciseDto
     */
    note?: string;
}
